import { Inject, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SessaoDiariaService } from '../services/auth/sessao-diaria.service';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class SessaoDiariaInterceptor implements HttpInterceptor {
  constructor(private sessao: SessaoDiariaService, private injector: Injector, @Inject('BASE_URL') private baseUrl: string) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = new URL(req.url, window.location.origin);
    const base = new URL(this.baseUrl, window.location.origin);
    const publico = /\/api\/(Usuario\/(GetByLogin|GetByEmail|SendEmail)|Sessao\/ValidarDia)\/?$/i.test(url.pathname);
    if (url.origin !== base.origin || !url.pathname.startsWith(base.pathname.replace(/\/$/, '') + '/api/') || publico || !(Number(localStorage.getItem('id')) > 0)) {
      return next.handle(req);
    }
    const identidade = this.sessao.identidade();
    return this.sessao.validar().pipe(switchMap(valida => {
      if (valida && identidade === this.sessao.identidade()) return next.handle(req);
      if (identidade === this.sessao.identidade()) this.injector.get(AuthService).exigirLoginDiario();
      return throwError(() => new HttpErrorResponse({ status: 401, error: { mensagem: 'Faça login novamente para continuar.' } }));
    }));
  }
}
